"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "autoReadings",
    path: "/auto-readings",
    component: "SensorDataBrowser"
});
let SensorDataBrowser = class SensorDataBrowser extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
        this.$$cache_timeTo = new core_1.ComponentValueCache(this, "timeTo", "SensorDataBrowser.timeTo");
    }
    getQueryParameters(...args) {
        return { time: this.timeTo };
    }
    onCreateMeterReadingsPayload(...args) {
        return this.$imodal
            .show({ name: 'CreateMeterReadingsParameters' })
            .then(result => {
            if (!result || result.cancel || !result.value) {
                return;
            }
            return {
                ...result.value,
                readings: this.selectedItems
                    .filter(p => !!p.meter_id)
                    .map(p => ({
                    meter_id: p.meter_id,
                    serial: p.meter_serial,
                    value: p.value,
                    unit: p.unit,
                    reading_type: 'automated',
                    reading_date: this.$fn.formatDate(this.$fn.parseISODate(p.timestamp), 'yyyy-MM-dd'),
                    reading_time: this.$fn.formatDate(this.$fn.parseISODate(p.timestamp), 'hh:mm'),
                }))
            };
        });
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    selectedItems;
    timeTo;
    async $$load_timeTo() {
        return new Date();
    }
    ds;
    async $$load_ds() {
        return this.$fn.slickDataSource('integro_api/list_auto_meter_readings', { parameters: this.getQueryParameters });
    }
    ux;
    b_7315092382398562_modalBindings;
    b_2248226175642056_columnDefaults;
    b_2248226175642056_columns;
    dataMembers = ['selectedItems', 'timeTo', 'ds', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                selectedItems: [],
                timeTo: null,
                ds: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
                b_2248226175642056_columnDefaults: {
                    sortable: true,
                    filterable: true,
                    resizable: true,
                    selectable: true,
                },
                b_2248226175642056_columns: [{
                        field: "meter_type",
                        name: this.$fn.pgettext("MeterSensorDataBrowser", "Meter Type"),
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            formatters: [{
                                    name: "gettext",
                                    context: "MeterTypes",
                                    conversion: "StartCase",
                                    filterInput: true,
                                },
                            ],
                        },
                    },
                    {
                        field: "meter_serial",
                        name: this.$fn.pgettext("MeterSensorDataBrowser", "Meter"),
                        type: "command",
                        formatter: {
                            name: "routeLink",
                            to: "meter",
                            params: {
                                id: "meter_id",
                            },
                        },
                    },
                    {
                        field: "tag_id",
                        name: this.$fn.pgettext("MeterSensorDataBrowser", "Meter Tag"),
                        type: "command",
                        formatter: {
                            name: "routeLink",
                            to: "meter",
                            params: {
                                id: "meter_id",
                            },
                        },
                    },
                    {
                        field: "sensor",
                        name: this.$fn.pgettext("MeterSensorDataBrowser", "Sensor Key"),
                    },
                    {
                        field: "raw",
                        name: this.$fn.pgettext("MeterSensorDataBrowser", "Raw"),
                        textAlign: "right",
                        formatter: {
                            name: "number",
                        },
                        cssClass: "text-muted",
                    },
                    {
                        field: "offset",
                        name: this.$fn.pgettext("MeterSensorDataBrowser", "Offset"),
                        textAlign: "right",
                        formatter: {
                            name: "number",
                        },
                        cssClass: "text-muted",
                    },
                    {
                        field: "value",
                        name: this.$fn.pgettext("MeterSensorDataBrowser", "Value"),
                        textAlign: "right",
                        cssClass: "font-weight-bold",
                        formatter: {
                            name: "number",
                        },
                    },
                    {
                        field: "unit",
                        name: this.$fn.pgettext("MeterSensorDataBrowser", "Unit"),
                        cssClass: "font-weight-bold",
                    },
                    {
                        field: "timestamp",
                        name: this.$fn.pgettext("MeterSensorDataBrowser", "Timestamp"),
                        formatter: {
                            name: "datetime",
                        },
                    },
                    {
                        field: "rentals",
                        name: this.$fn.pgettext("MeterSensorDataBrowser", "Rentals"),
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            separator: ", ",
                            formatterContext: "item",
                            formatters: [{
                                    name: "getvalue",
                                    opts: {
                                        field: "name",
                                        source: "value",
                                    },
                                },
                                {
                                    name: "routeLink",
                                    to: "rental",
                                    navigateOnIconClick: true,
                                    params: {
                                        id: "id",
                                    },
                                },
                            ],
                        },
                    },
                    {
                        field: "tenants",
                        name: this.$fn.pgettext("MeterSensorDataBrowser", "Tenants"),
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            separator: ", ",
                            formatterContext: "item",
                            formatters: [{
                                    name: "getvalue",
                                    opts: {
                                        field: "name",
                                        source: "value",
                                    },
                                },
                                {
                                    name: "routeLink",
                                    to: "company",
                                    navigateOnIconClick: true,
                                    params: {
                                        id: "id",
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("MeterSensorDataBrowser", "Auto Readings"),
                icon: "fa-ethernet",
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_7668_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_setData_7670_getActionArgs($event) {
        return {
            path: "selectedItems",
            value: this.$refs.grid.getSelectedItems(),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_2248226175642056_selectedRowsChanged(event, scope) {
        return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_7668 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_7668_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_7667 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_7668,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_7667],
        });
        const act_2248226175642056_setData_7670 = new core_1.actions.SetDataAction({
            actionArgs: this.act_2248226175642056_setData_7670_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_selectedRowsChanged_7669 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_setData_7670,
            event: "selectedRowsChanged",
            displayName: "setData",
        });
        const evh_2248226175642056_selectedRowsChanged = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_selectedRowsChanged_7669],
        });
        return {
            act_7315092382398562_closeModal_7668,
            evh_7315092382398562_close_7667,
            evh_7315092382398562_close,
            act_2248226175642056_setData_7670,
            evh_2248226175642056_selectedRowsChanged_7669,
            evh_2248226175642056_selectedRowsChanged,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], SensorDataBrowser.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], SensorDataBrowser.prototype, "onSize", null);
SensorDataBrowser = __decorate([
    (0, vue_property_decorator_1.Component)()
], SensorDataBrowser);
exports.default = SensorDataBrowser;
vue_property_decorator_1.Vue.component("SensorDataBrowser", SensorDataBrowser);
